export const Enum = {
    "numberOfRec": 10
}